import React, { ReactNode } from 'react';
import Styles from "./Pb.module.scss";

export const Pb = (
	{
		children
	}: {
		children: ReactNode
	}
) => (
	<p className={Styles.p}>
		{children}
	</p>
);

export default Pb;
